import { UseMelioFormResults } from '@melio/penny';
import { usePaymentSettings } from '@melio/platform-api';
import { converDateToStringRepresentation } from '@melio/platform-utils';
import { useState } from 'react';

import { PaymentFlowFormFields, PaymentSettingsFetchParams } from '../types';

export const usePaymentSettingsData = ({
  form,
  defaultValues,
}: {
  form: UseMelioFormResults<PaymentFlowFormFields>;
  defaultValues: Partial<PaymentFlowFormFields>;
}) => {
  const [paymentSettingsParams, setPaymentSettingsParams] = useState<PaymentSettingsFetchParams>(defaultValues);

  const fetchPaymentSettings = () => {
    const { vendorId, deliveryMethodId, fundingSourceId, amountToPay, deliveryDate, deliveryPreference } =
      form.getValues();
    setPaymentSettingsParams({
      vendorId,
      deliveryMethodId,
      fundingSourceId,
      amountToPay,
      deliveryDate,
      deliveryPreference,
    });
  };

  const { data: [paymentSettings] = [], isLoading } = usePaymentSettings({
    enabled: Boolean(paymentSettingsParams.vendorId),
    fillWithDefaults: true,
    params: paymentSettingsParams.vendorId
      ? [
          {
            vendorId: paymentSettingsParams.vendorId,
            deliveryMethodId: paymentSettingsParams.deliveryMethodId,
            fundingSourceId: paymentSettingsParams.fundingSourceId,
            amountToPay: paymentSettingsParams.amountToPay ? Number(paymentSettingsParams.amountToPay) : 0,
            dueDate: converDateToStringRepresentation(paymentSettingsParams.deliveryDate),
            deliveryPreferenceType: paymentSettingsParams.deliveryPreference,
            invoicesData: [],
          },
        ]
      : [],
  });

  return {
    paymentSettings,
    fetchPaymentSettings,
    isLoading,
  };
};
